import { useQuery } from 'react-query';
import { JudgeAPI } from 'api/admin/judge';
import { JUDGES } from 'helpers/constants';

export default function useRingJudges(ringId) {
  return useQuery([JUDGES, ringId], () => JudgeAPI.getJudgesForRing(ringId), {
    enabled: ringId,
  });
}
